import * as fromDatatype from '../datatype-library';

export interface bl_inv_pdg_unique_category_combination_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    category_l1_code:fromDatatype.VrsnDataFieldInterface;
    category_l2_code:fromDatatype.VrsnDataFieldInterface;
    category_l3_code:fromDatatype.VrsnDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    category_l1_guid: fromDatatype.GuidDataFieldInterface;
    category_l2_guid: fromDatatype.GuidDataFieldInterface;
    category_l3_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
}

export class bl_inv_pdg_unique_category_combination_line_RowClass implements bl_inv_pdg_unique_category_combination_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    category_l1_code:fromDatatype.VrsnDataFieldInterface;
    category_l2_code:fromDatatype.VrsnDataFieldInterface;
    category_l3_code:fromDatatype.VrsnDataFieldInterface;
    category_l1_guid: fromDatatype.GuidDataFieldInterface;
    category_l2_guid: fromDatatype.GuidDataFieldInterface;
    category_l3_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
}
